import React, { FC, Fragment, ReactElement, useEffect, useState } from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { ExerciseModal } from "../../../../models/ExerciseModal/Exercise.model";
import QuestionModel from "../../../../models/ExerciseModal/Question.model";
import { ExamExerciseQuestionService } from "../../../../services/ExamService/ExerciseService/question.service";
import QuestionService from "../../../../services/QuestionService/Question.service";
import UIModal from "../../../../shared/components/UIModal";
import Description from "./Description";
import "./displayExercise.scss";
import DisplayQuestion from "./DisplayQuestion";
import { Skeleton } from "antd";

interface DisplayExerciseProps extends RouteComponentProps {
	visible: boolean;
	exercise: ExerciseModal;
	closeModal: () => void;
}


const genTime = (timeOption?: string, time?: any) => {
	switch (timeOption) {
		case "whole_quiz":
			console.log(time);
			return "Whole Quiz" + " - " + time + "mins";
		case "per_question":
			return "Per Question" + " - " + time + "sec";
		default:
			console.log({ default: time });
			return "No Timer";
	}
};

const DisplayExercise: FC<DisplayExerciseProps> = ({ exercise, ...rest }) => {
	const [questions, setQuestions] = useState<QuestionModel[]>([]);
	const [loading, setLoading] = useState(true);
	const [timeDesc, setTimeDesc] = useState("");




	useEffect(() => {	
		if (exercise) {
			setLoading(true);
			setTimeDesc(genTime(exercise?.timerOptions, exercise?.time))
			rest.location.pathname.includes("exams") ?
				ExamExerciseQuestionService.getQuestionsbyExerciseId(
					exercise?.id,
					(questions: any) => {
						setQuestions(questions)
						setLoading(false);
					},
					() => {
						setQuestions([])		
						setLoading(false);
					}
				) :
				QuestionService.getQuestionsByExercise(
					{ excercise_id: exercise?.id },
					(questions) => {
						setQuestions(questions);
						setLoading(false);
					},
					() => {
						setQuestions([])			
						setLoading(false);
					}
				);
		}
	}, [exercise]);

	return (
		<UIModal {...rest} noControl>
			<div className="display-exercise">
				<h1 className="title">
					{exercise?.position} - {exercise?.title}
				</h1>
				<p className="timing">
					{timeDesc}
				</p>
				<Description
					showLength={100}
					text={exercise?.description ?? ""}
					className="description"
				/>
				<div className="question__wrapper">
					{loading ? (
						<>
						<Skeleton active avatar  />
						<Skeleton active avatar  />
						</>
						
					) : questions?.map((question, index) => (
						<DisplayQuestion question={question} index={index} />
					))}
				</div>
			</div>
		</UIModal>
	);
};

export default withRouter(DisplayExercise);
